<template>
<div class="chapter">
<div class="inner_page">
<p class="C63"><a id="page_xv">Author’s Notes</a></p><a id="page_xv">
<p class="P17">All Japanese names will be given following the Japanese convention of family name first followed by personal name (unless they are scholars based outside of Japan who publish in English). For example, Prime Minister Abe Shinzō.</p>
<p class="P18">Although currency rates fluctuated throughout the period of my fieldwork (2008–13), ¥100 can be considered to be roughly equivalent to US$1.</p>
<p class="P18">All translations of Japanese sources are my own unless otherwise indicated.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Author_s_Notes.vue?433ed362